import { Database, FileSpreadsheet, LayoutDashboard, Network, Server, UserRound } from "lucide-react";

const mfaDbNavigation = [
  {
    key: "/pam/databases/dashboard",
    icon: <LayoutDashboard className="icon" />,
    label: "Dashboard",
    navigate: "/pam/databases/dashboard",
  },
  {
    key: "/pam/databases",
    icon: <Database className="icon" />,
    label: "Databases",
    navigate: "/pam/databases",
  },
  {
    key: "/pam/databases/agents",
    icon: <Server className="icon" />,
    label: "Agents",
    navigate: "/pam/databases/agents",
  },
  {
    key: "/pam/databases/users",
    icon: <UserRound className="icon" />,
    label: "Users",
    navigate: "/pam/databases/users",
  },
  {
    key: "/pam/policies/database",
    icon: <FileSpreadsheet className="icon" />,
    label: "Policies",
    navigate: "/pam/policies/database",
  },
  {
    key: "/pam/databases/connections",
    icon: <Network className="icon" />,
    label: "Connections",
    navigate: "/pam/databases/connections",
  },
];

export default mfaDbNavigation;
